import './locales/register'
import { lazy } from 'react'
import ErrorPage from '@/components/ErrorBoundary/ErrorPage'

import { RouteObject } from 'react-router-dom'

const DocumentCreate = lazy(() =>
    import('./components/Create').then((m) => ({ default: m.DocumentCreate }))
)
const ListDocuments = lazy(() => import('./components/List'))
const ShareDocuments = lazy(() => import('./components/Share'))
const DocumentUpdate = lazy(() =>
    import('./components/Update').then((m) => ({ default: m.DocumentUpdate }))
)
const ApproveDocument = lazy(() => import('./components/Approved'))

const DocumentModule: RouteObject = {
    path: 'documents',
    children: [
        {
            path: '',
            element: <ListDocuments />,
        },
        {
            path: 'share',
            element: <ShareDocuments />,
        },
        {
            path: 'new',
            element: <DocumentCreate />,
        },
        {
            path: ':documentID',
            children: [
                {
                    path: 'edit',
                    element: <DocumentUpdate />,
                },
            ],
        },
        {
            path: 'approved',
            element: <ApproveDocument />,
        },
    ],
    errorElement: <ErrorPage status={500} />,
}
export default DocumentModule
